import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
const styles = {
    container: {
        textAlign: 'center',
        width: '100%',
    },
    infoText: {
        padding: '10px',
        margin: '10px 0',
        fontSize: '14px',
        textAlign: 'left',
        color: 'white',
        backgroundColor: '#5f5f5f',
        borderRadius: '5px',
    },
    errorText: {
        color: 'red',
    },
};
const EDIT_SIGNAL_INFO_TEXT = `Focus on an input field and press Shift + Drag and Drop to draw a coupling constant in spectrum view.`;
const ADD_SIGNAL_INFO_TEXT = `Focus on the input field and press Shift + Left mouse click to select new signal delta value in spectrum view.`;
const InfoText = (props) => {
    const { value, type = 'info' } = props;
    return (_jsx("p", { style: { ...styles.infoText, ...(type === 'error' && styles.errorText) }, children: value }));
};
export function InfoBlock() {
    const { values, errors, } = useFormikContext();
    return (_jsx("div", { style: {
            textAlign: 'center',
            width: '100%',
        }, children: errors.signals &&
            (errors.signals.noSignals || errors.signals.noCouplings) ? (_jsxs("div", { children: [_jsx("p", { className: "error-text", children: errors.signals.noSignals || errors.signals.noCouplings[0].message }), errors.signals.noSignals && (_jsx(InfoText, { value: ADD_SIGNAL_INFO_TEXT }))] })) : values.signalIndex === '-1' ? (_jsx(InfoText, { value: ADD_SIGNAL_INFO_TEXT })) : (_jsx(InfoText, { value: EDIT_SIGNAL_INFO_TEXT })) }));
}
